import mutations from './mutations';
import StateIdentifiers from './state-identifiers';

/**
 * Creates an install factory that is used to expose utility functions in the view-model scopes
 * of Vue.
 * @param {string} storeModuleName
 * @param {string} componentName
 * @param {Function} createComponent
 * @returns {Function}
 */
export default function createInstaller({storeModuleName, componentName, createComponent}) {
    /* eslint-disable no-param-reassign */
    return (Vue) => {
        /* eslint-disable func-names */
        Vue.prototype.$startLoading = function (identifier) {
            this.$store.dispatch(`${storeModuleName}/${mutations.start}`, identifier, {root: true});
        };

        Vue.prototype.$stopLoading = function (identifier) {
            this.$store.dispatch(`${storeModuleName}/${mutations.stop}`, identifier, {root: true});
        };

        Vue.prototype.$startLoadingPage = function () {
            this.$store.dispatch(`${storeModuleName}/${mutations.start}`, StateIdentifiers.application, {root: true});
        };

        Vue.prototype.$stopLoadingPage = function () {
            this.$store.dispatch(`${storeModuleName}/${mutations.stop}`, StateIdentifiers.application, {root: true});
        };

        Vue.prototype.$isLoading = function (identifier) {
            return this.$store.getters[`${storeModuleName}/isLoading`](identifier);
        };

        Vue.prototype.$isPageLoading = function () {
            return this.$store.getters[`${storeModuleName}/isLoading`](StateIdentifiers.application);
        };

        Vue.prototype.$someLoading = function () {
            return this.$store.getters[`${storeModuleName}/someLoading`];
        };

        // define dynamic component
        Vue.component(componentName, createComponent({storeModuleName}));
    };
}
